import { has, template, } from 'lodash';
const TEMPLATE_CACHE = {};
export function format(template_str, params) {
    let fn;
    if (has(TEMPLATE_CACHE, template_str)) {
        fn = TEMPLATE_CACHE[template_str];
    }
    else {
        fn = template(template_str);
        TEMPLATE_CACHE[template_str] = fn;
    }
    return fn(params);
}
